import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormCamisaTrieurBuild } from './forms-build/form-camisa-trieur-build';

export class FormCamisaTrieur extends FormCamisaTrieurBuild {
  public createFormCamisaTrieur(formBuilder: FormBuilder): FormGroup {
    const formulario: FormGroup = formBuilder.group({
      id: [0, []],
      created_by: ['', []],
      site: ['', []],  // Corrigido
      data_estrategia: ['', []],
      hibrido_rnc: ['', []],  // Corrigido
      safra: ['', []],
      lote_ds: ['', []],
      volume_analisado_kg: ['', []],  // Corrigido
      rendimento_r1m: ['', []],
      rendimento_r2: ['', []],
      rendimento_r3: ['', []],
      rendimento_c1m: ['', []],
      rendimento_c2: ['', []],
      rendimento_c3: ['', []],
      min_r1m: ['', []],
      min_r2: ['', []],
      min_r3: ['', []],
      min_c1m: ['', []],
      min_c2: ['', []],
      min_c3: ['', []],
      max_r1m: ['', []],
      max_r2: ['', []],
      max_r3: ['', []],
      max_c1m: ['', []],
      max_c2: ['', []],
      max_c3: ['', []],
      range_r1m: ['', []],
      range_r2: ['', []],
      range_r3: ['', []],
      range_c1m: ['', []],
      range_c2: ['', []],
      range_c3: ['', []],
      sdev_r1m: ['', []],
      sdev_r2: ['', []],
      sdev_r3: ['', []],
      sdev_c1m: ['', []],
      sdev_c2: ['', []],
      sdev_c3: ['', []],
      resultado_r1m: ['', []],
      resultado_r2: ['', []],
      resultado_r3: ['', []],
      resultado_c1m: ['', []],
      resultado_c2: ['', []],
      resultado_c3: ['', []],
      linha: ['', []],  // Novo campo
      peneira: ['', []],  // Novo campo
      tag_trieur: ['', []],  // Novo campo
      camisa: ['', []],  // Novo campo
      fracao_enviada_silo: ['', []],  // Novo campo
      responsavel_lancamento: ['', []],
      responsavel_analise: ['', []],
      observacoes: ['', []],  // Corrigido
      origem_negocio: ['', []]  // Novo campo

    });
    return formulario;
  }
}
